import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

import { getKickOffSectionKey } from './getSectionData';

export const getKomTechnicalWirReactiveScopeData = (wir: WIR | null, countryState: string) => {
  const komTechWirPhase = getKickOffSectionKey(countryState);
  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : komTechWirPhase;
  const wellInformation = wir?.phases?.[phase]?.sections?.wellInformation;
  const reviewChecklistActions = wir?.phases?.[phase]?.sections?.reviewChecklistActions;
  const budget = wir?.phases?.[phase]?.sections?.budget;

  return {
    phase,
    wellInformation,
    reviewChecklistActions,
    budget,
  };
};
